<div class="pt-5 bg-white">
    <div class="row ml-0">
        <div class="col-1"></div>
        <div class="col-5">
            <div class="d-flex">
                <div>
                    <div class="header-content">
                        People
                    </div>
                    <div class="sub-content mt-3">
                        Hello. Here, you can view and manage profiles of peer supporters and peer mentors.
                    </div>
                </div>
            </div>
        </div>
        <div class="col-5 d-flex">
            <div class="input-group">
                <input class="form-control py-2 border-0" type="text" placeholder="Search" id="example-search-input" style="background:#F6FAFA;" (keydown.enter)="searchInUserList()" [(ngModel)]="searchUser">
                <span class="input-group-append">
                    <button class="btn btn-outline-secondary border-0 pb-0" *ngIf="searchUser" (click)="clearSearchUserList()" id="clear-search" type="button" style="height: calc(1.5em + 0.75rem + 2px);background:#F6FAFA;"> 
                      <mat-icon class="font-18 m-auto">clear</mat-icon>
                    </button>
                  </span>
                <span class="input-group-append">
                  <button class="btn btn-outline-secondary border-0" (click)="searchInUserList()" id="search" type="button" style="height: calc(1.5em + 0.75rem + 2px);border-left:1px solid #ced4da !important;background:#F6FAFA;"> 
                    <mat-icon>search</mat-icon>
                  </button>
                </span>
            </div>
            <button class="btn d-flex justify-content-center ml-3 primary-bg text-white" (click)="addNewPeer()" style="width:200px;height: calc(1.5em + 0.75rem + 2px);"><mat-icon style="margin-right: 10px;">add</mat-icon> <span>Add New</span></button>
        </div>
        <div class="col-1"></div>
    </div>

    <div class="row ml-0">
        <div class="col-1"></div>
        <div class="col-5 my-4" id="user-toggle">
            <mat-button-toggle-group [(ngModel)]="currentUserType" (ngModelChange)="getUserListByType()">
                <mat-button-toggle value="Mentor" disableRipple>Mentors</mat-button-toggle>
                <mat-button-toggle value="Supporter" disableRipple>Supporters</mat-button-toggle>
            </mat-button-toggle-group>
        </div>
        <div class="col-5 d-flex justify-content-end align-items-center">
            <mat-checkbox class="example-margin" [checked]="showInactiveUser" (change)="setUsersList($event.checked)">
            </mat-checkbox>
            <span class="primary-txt" style="margin-top: -8px;margin-left: 10px;">
                Inactive User
            </span>
        </div>
    </div>
</div>

<div>
    <div class="row ml-0 align-items-center h-60">
        <div class="col-1 mt-2 d-flex justify-content-end align-items-center">
            <mat-checkbox class="example-margin" id="user-select-all" *ngIf="usersList.length" [checked]="selectAllUser" [indeterminate]="checkSelectAll()" (change)="setSelectAllUser($event.checked)">
            </mat-checkbox>
        </div>
        <div class="col-9">
            <div class="d-flex">
                <div class="primary-txt font-15">Peers -</div>
                <div class="pl-2">
                    <span *ngIf="isSearched && !showDelete()">{{searchCount}} /</span>
                    <span *ngIf="showDelete()" class="text-danger">{{getSelectedUserCount()}} /</span>
                    <span class="primary-txt"> {{totalUser}}</span></div>
            </div>
        </div>
        <div class="col-1 d-flex justify-content-end" [ngStyle]="{ 'padding-right': getScrollableWidth() + 16 + 'px'}" *ngIf="showDelete()">
            <button class="btn d-flex delete-btn " (click)="deleteUserModel()">
                <span class="font-14 ml-1">Delete</span>
                <span class="font-20 material-symbols-rounded">
                    delete
                </span>
            </button>
        </div>
    </div>
    <div class="user-list-container" id="users-card-list" (scroll)="onScroll($event)">
        <ng-container *ngFor="let user of usersList;let i=index">
            <div class="row ml-0 pb-4">
                <div class="col-1 d-flex justify-content-end align-items-center">
                    <mat-checkbox [(ngModel)]="user.selected" (ngModelChange)="updateAllUser()">
                    </mat-checkbox>
                </div>
                <div class="col-10 mr-0">
                    <mat-card [ngClass]="{'active-card ': user.selected}" class="shadow-sm" (click)="setUpdateUser(user.user_id)">
                        <mat-card-content>
                            <div class="row p-2 align-items-center cursor" style="line-height: 20px;">
                                <div class="col-3">
                                    <div class="font-weight-bold ellipsis text-capitalize" data-toggle='tooltip' title="{{user.first_name}}">{{ user.first_name}} {{user.last_name}}</div>
                                    <div class="ellipsis" data-toggle='tooltip' title="{{user.age}}, {{user.gender}}{{(user.sexuality ? ', '+user.sexuality : '')}}">
                                        {{user.age}}, {{user.gender}}{{(user.sexuality ? ", "+user.sexuality : '')}}</div>
                                </div>
                                <div class="col-4 ellipsis" data-toggle='tooltip' title="{{user.email_id}}">{{user.email_id}}</div>
                                <div class="col-3 ellipsis" data-toggle='tooltip' title="{{user.languages}}" *ngIf="!showInactiveUser">{{user.languages}}</div>
                                <div class="col-2 ellipsis" data-toggle='tooltip' title="{{user.city}}">{{user.city}}</div>
                                <div class="col-3 ellipsis d-flex justify-content-center" data-toggle='tooltip' *ngIf="showInactiveUser">
                                    <div class="d-flex cursor" (click)="resendActivationCode(user.user_id, $event)">
                                        <span class="font-14 ml-1 primary-btn-txt">Resent code</span>
                                    </div>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>
        </ng-container>
    </div>
</div>
<button class="d-none" id="deleteModelPopup" data-target="#delete-view" data-toggle="modal"></button>
<div class="modal" id="delete-view">
    <div class="modal-dialog">
        <div class="modal-content sub-content" style="border-radius: 10px">

            <div class="modal-body text-center">
                <span class="material-symbols-rounded primary-btn-txt" style="font-size: 60px;">
                    delete
                </span>
                <h4 class="modal-title">Are you sure?</h4>

                <p>Do you really want to delete these records? </p>
                <div class="d-flex align-items-center justify-content-center py-2">
                    <div class="cursor w-25 primary-btn-txt font-15 mr-4" data-dismiss="modal">Cancel</div>
                    <button class="btn d-flex justify-content-center align-items-center ml-3 font-15 w-25 h-25 primary-bg text-white" data-dismiss="modal" (click)="deleteUsers()">Delete</button>
                </div>
            </div>

        </div>
    </div>
</div>